throw new Error('This Backendless JS SDK assembly is not intended for Node.js environment. You should use "lib" folder modules instead. For any questions please contact as at http://support.backendless.com/')


//////////////////
// WEBPACK FOOTER
// external "http"
// module id = 10
// module chunks = 0